import { computed, set } from 'vue-demi';
export default (props, isEditor) => {
    const contentCanFold = computed(() => {
        if (isEditor) {
            return !props.isFold;
        }
        return true;
    });
    const handleShowContent = (item) => {
        if (isEditor) {
            return;
        }
        // 如果是点击当前索引，则隐藏当前点击的索引
        set(item, 'isExpand', !item.isExpand); // 兼容处理 用$set
    };
    const displayContent = (item) => {
        return isEditor || item.isExpand;
    };

    return {
        contentCanFold,
        handleShowContent,
        displayContent
    };
};
